export default "__VITE_ASSET__D$chXDKP__"